import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button } from 'reactstrap'
import './index.scss'

import masterPromotionA from '../../assets/images/promotion/master_promotion_01.gif'
import masterPromotionB from '../../assets/images/promotion/master_promotion_02.jpg'

class Promotion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [
        {
          title: 'แฟรนไชส์ เราไม่ขาย เราแจก ฟรี!!',
          subTitle: 'สนใจติดต่อ 02-190-6090, 081-806-2929',
          text: 'โปรแรงช่วยสู้ COVID กับแฟรนไชส์ ลูกชิ้น-ไส้กรอกนายฮั่ง มัดจำเพียง 2,500 บาท',
          src: masterPromotionA,
          pathname: '/promotion-detail'
        },
        {
          title: 'โฉมใหม่!!',
          subTitle: 'สนใจติดต่อ 02-190-6090, 081-806-2929',
          text: 'เพิ่มจำนวน แต่ราคาเท่าเดิม',
          src: masterPromotionB,
          pathname: '/product-detail'
        }
      ]
    }
  }
  render() {
    return (
      <div className="ch-promotion" id="promotion">
        <div className="container-lg">
          <h1
            className="display-4 text-center font-weight-bold m-0"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="text-icon">
              <FontAwesomeIcon icon="bullhorn" />
            </div>
            <span>โปรโมท</span>
          </h1>
          <div className="row">
            {this.state.items.reverse().map((item, i) => {
              return (
                <div className="col-12 mt-5" key={i}>
                  <Card className="ch-promotion-item" data-aos="fade-up" data-aos-duration="3000">
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.props.history.push(item.pathname)}
                    >
                      <CardImg top width="100%" src={item.src} alt="chefhung-promotion" />
                    </div>
                    <CardBody>
                      <CardTitle className="text-primary font-weight-bold">
                        <h2 className="m-0">{item.title}</h2>
                      </CardTitle>
                      <CardSubtitle className="text-secondary">
                        <h5 className="m-0">{item.subTitle}</h5>
                      </CardSubtitle>
                      <CardText className="my-3">{item.text}</CardText>
                      <Button
                        color={'primary'}
                        style={{ color: '#fff' }}
                        onClick={() => this.props.history.push(item.pathname)}
                      >
                        ดูรายละเอียด
                      </Button>
                    </CardBody>
                  </Card>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Promotion)
